import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import { supportedLanguages } from '@/constants'
import { companyModeProcessor } from './companyModeProcessor'
import ar from './localization/ar.json'
import de from './localization/de.json'
import en from './localization/en.json'
import arExerciseNames from './localization/exercise_names/ar.json'
import deExerciseNames from './localization/exercise_names/de.json'
import enExerciseNames from './localization/exercise_names/en.json'
import itExerciseNames from './localization/exercise_names/it.json'
import fr from './localization/fr.json'
import it from './localization/it.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(companyModeProcessor)
  .init({
    fallbackLng: 'en',
    load: 'languageOnly',
    supportedLngs: supportedLanguages.map(({ code }) => code),
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    nonExplicitSupportedLngs: true,
    react: {
      useSuspense: true
    },
    interpolation: {
      escapeValue: false
    },
    postProcess: ['companyMode'],
    resources: {
      en: { translation: { ...en, exercise_names: enExerciseNames } },
      fr: { translation: { ...fr } },
      it: { translation: { ...it, exercise_names: itExerciseNames } },
      de: { translation: { ...de, exercise_names: deExerciseNames } },
      ar: {
        translation: { ...ar, exercise_names: arExerciseNames },
        direction: 'rtl'
      }
    },
    debug: process.env.NODE_ENV === 'development'
  })

export default i18n
